<app-grid-wrapper
  #grid
  [gridSize]="GridSize.small"
  persistenceKey="pendingPaymentList"
  [autoHeight]="false"
></app-grid-wrapper>
